import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges,ChangeDetectorRef,OnDestroy } from '@angular/core';
import { AppSettings } from 'src/app/shared/app-settings';
import { ChartType } from 'chart.js';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';

//import * as d3 from "d3"; 

declare var d3: any;

@Component({
  selector: 'app-performance-dashboard',
  templateUrl: './performance-dashboard.component.html',
  styleUrls: ['./performance-dashboard.component.css']
,
  standalone: false
})
export class PerformanceDashboardComponent implements OnInit,AfterViewInit,OnChanges  {

  @Input() siteFromDate:any;
  @Input() siteToDate:any;
  @Input() siteUnitId:any;
  @Input() siteAccName:any;

  gaugemap:any = {};
  dataLoaded = false;
  barChartLength: number = 0;
  barThickness: number = 0;
  maxBarThickness = 20;

  public barChartType:ChartType  = 'bar';
  public barChartLegend:boolean = true;
  public barChartLabels: string[];



  public barChartColors:Array<any> = [{}];
  barChartOptions: any;
  performanceData: Object;
  upTime: Object;
  downTime: any;
  partialtime: any;
  barChartData: any=[]
  up: any;
  down: any;
  partial: any;
  schedule: any;
  toDate: any;
  fromDate: any;
  loadingUserMessage: string = "Loading ...";
  isLoading: boolean = false;
                  
  constructor(private http: HttpClient,private cdr: ChangeDetectorRef,public spinner: SpinnerService,
    ) { }

  ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      if (propName === 'siteFromDate' || propName === 'siteToDate' || propName === 'siteUnitId') {
        this.fetchDataAndDrawChart();
        break;
      }
    }
  }
 
  ngOnInit(): void {
    this.fetchDataAndDrawChart();
  }

  fetchDataAndDrawChart(): void {
    const date1 = new Date(this.siteFromDate);
    const date2 = new Date(this.siteToDate);
    const date11 = new Date(date1);
    this.siteUnitId;
    const formattedDate1 = date11?.toISOString();
    const date22 = new Date(date2);
    const formattedDate2 = date22?.toISOString();
    this.isLoading = true;
    this.spinner.activate();
    let url = AppSettings.API_ENDPOINT + '/' + AppSettings.AVG_TIME;
    let payload = {
      "site_id":this.siteUnitId,
      "start_date":formattedDate1,
      "end_date":formattedDate2
    }
    this.http.post(url,payload).subscribe(response => {
      if(response['data'] != undefined || response['data'] != null){
      this.performanceData = response
      this.downTime = this.performanceData['data']['average']['downtime']
      this.upTime = this.performanceData['data']['average']['uptime']
      this.partialtime = this.performanceData['data']['average']['partialtime']
      this.barChartLabels = this.performanceData['days'].map(item => {
        let parts = item.date.split('/');
        return `${parts[1]}/${parts[0]}/${parts[2]}`;
    })};

      this.barChartData = [
        { data: [], label: 'UP TIME',backgroundColor: '#5FB47B',hoverBackgroundColor: '#5FB47B',barThickness: this.barChartLabels?.length < 50 ? 20 : 20},
        { data: [], label: 'DOWN TIME',backgroundColor: '#DC3545',hoverBackgroundColor: '#DC3545',barThickness: this.barChartLabels?.length > 50 ? 10 : 20},
        { data: [], label: 'PSD TIME',backgroundColor:'#F9B15F',hoverBackgroundColor: '#F9B15F',barThickness: this.barChartLabels?.length < 50 ? 20 : 20},
        { data: [], label: 'SOLAR SCRIPT HOURS',backgroundColor:'#4A90E2',hoverBackgroundColor: '#4A90E2',barThickness: this.barChartLabels?.length < 50 ? 20 : 20}
      ];

      if(this.performanceData !=undefined || this.performanceData !=null){
      this.up = this.performanceData['days'].map(item=>item.up);
      this.down = this.performanceData['days'].map(item=>item.down);
      this.partial = this.performanceData['days'].map(item=>item.partial_down);
      this.schedule = this.performanceData['days'].map(item=>item.schedule_time);
      }

      this.barChartData[0].data = this.up;
      this.barChartData[1].data = this.down;
      this.barChartData[2].data = this.partial;
      this.barChartData[3].data = this.schedule;
      this.cdr.detectChanges();
      this.draw();
      this.isLoading = false;
      this.spinner.deactivate();
   });

    this.barChartOptions = {
      responsive: true,
      scales: {
        xAxes: [
          {
            stacked: true,
          },
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              stepSize: 20,
              beginAtZero: true,
              max: 100,
            },
          },
        ],
      },
      barThickness: 20,
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (value % 1 === 0) {
              return value + '%';
            } else {
              return value.toFixed(2) + '%';
            }
          }
        }
      }    
    };

  }

  uptime_csv(event: Event){
    event.preventDefault();
    const fromDate = new Date(this.siteFromDate);
    const toDate = new Date(this.siteToDate);
    const formattedstartDate = fromDate?.toISOString();
    const formattedendDate = toDate?.toISOString();
    this.isLoading = true;
    this.spinner.activate();
    let url = AppSettings.API_ENDPOINT + '/' + AppSettings.UPTIME_CSV;
    let payload = {
      "site_id":this.siteUnitId,
      "start_date":formattedstartDate,
      "end_date":formattedendDate
    }
    this.http.post(url,payload, { responseType: 'text' }).subscribe((response)=>{
      const blob = new Blob([response], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${this.siteAccName || this.siteUnitId} (uptime)`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
      this.spinner.deactivate();
    },(error)=>{
      this.spinner.deactivate();
    })
  }

  ngAfterViewInit(): void {  }

  draw() {
    var self = this;
    var gauge = function (container, configuration) {

      var config = {
        size: 710,
        clipWidth: 200,
        clipHeight: 50,
        ringInset: 20,
        ringWidth: 20,

        pointerWidth: 10,
        pointerTailLength: 5,
        pointerHeadLengthPercent: 0.9,

        minValue: 0,
        maxValue: 100,

        minAngle: -90,
        maxAngle: 90,

        transitionMs: 750,

        majorTicks: 10,
        labelFormat: d3.format('d'),
        labelInset: 10,

        arcColorFn: d3.interpolateHsl(d3.rgb('#e8e2ca'), d3.rgb('#3e6c0a'))
      };

      var range = undefined;
      var r = undefined;
      var pointerHeadLength = undefined;
      var value = 0;

      var svg = undefined;
      var arc = undefined;
      var scale = undefined;
      var ticks = undefined;
      var tickData = undefined;
      var pointer = undefined;

      var donut = d3.pie();

      function deg2rad(deg) {
        return deg * Math.PI / 180;
      }

      function newAngle(d) {
        var ratio = scale(d);
        var newAngle = config.minAngle + (ratio * range);
        return newAngle;
      }

      function configure(configuration) {
        var prop = undefined;
        for (prop in configuration) {
          config[prop] = configuration[prop];
        }

        range = config.maxAngle - config.minAngle;
        r = config.size / 2;
        pointerHeadLength = Math.round(r * config.pointerHeadLengthPercent);

        scale = d3.scaleLinear()
          .range([0, 1])
          .domain([config.minValue, config.maxValue]);

        ticks = scale.ticks(config.majorTicks);
        tickData = d3.range(config.majorTicks).map(function () { return 1 / config.majorTicks; });

        arc = d3.arc()
          .innerRadius(r - config.ringWidth - config.ringInset)
          .outerRadius(r - config.ringInset)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + (ratio * range));
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + (ratio * range));
          });
      }
      self.gaugemap.configure = configure;

      function centerTranslation() {
        return 'translate(' + r + ',' + r + ')';
      }

      function isRendered() {
        return (svg !== undefined);
      }
      self.gaugemap.isRendered = isRendered;

      function render(newValue) {
        svg = d3.select(container)
          .append('svg:svg')
          .attr('class', 'gauge')
          .attr('width', config.clipWidth)
          .attr('height', config.clipHeight);


        var centerTx = centerTranslation();

        var arcs = svg.append('g')
          .attr('class', 'arc')
          .attr('transform', centerTx);

        arcs.selectAll('path')
          .data(tickData)
          .enter().append('path')
          .attr('fill', function (d, i) {
            return config.arcColorFn(d * i);
          })
          .attr('d', arc);

        var lg = svg.append('g')
          .attr('class', 'label')
          .attr('transform', centerTx);
        lg.selectAll('text')
          .data(ticks)
          .enter().append('text')
          .attr('transform', function (d) {
            var ratio = scale(d);
            var newAngle = config.minAngle + (ratio * range);
            return 'rotate(' + newAngle + ') translate(0,' + (config.labelInset - r) + ')';
          })
          .style('font-size', '10px')
          .text(config.labelFormat);
          
          var group = svg.append('g')
          .attr('transform', 'translate(' + (config.clipWidth / 2) + ',' + 200 + ')')
          .style('display', 'flex')
          .style('flex-direction', 'row')
          .style('align-items', 'center');

          group.append('text')
          .attr('class', 'title')
          .attr('x', 0)
          .attr('text-anchor', 'end')
          .style('font-size', '20px')
          .style('font-weight', 'bold')
          .style('fill', '#3e6c0a')
          .text('UP TIME');

          var upTime;
          var upTimeText;
          if (typeof self.upTime === 'number') {
            upTime = self.upTime;
          } else if (typeof self.upTime === 'string') {
            upTime = parseFloat(self.upTime);
          } else {
          }          
          if (upTime % 1 === 0) {
            upTimeText = parseInt(upTime.toString()) + ' '+'%';
          } else {
            upTimeText = upTime.toFixed(2) + ' ' + '%';
          }  

          var textWidth = 100;
          var textHeight = 30;
          
          group.append('rect')
          .attr('x', 25)
          .attr('y', -23)
          .attr('width', textWidth)
          .attr('height', textHeight)
          .attr('rx', 10)
          .attr('ry', 10)
          .style('fill', '444444');
      
          group.append('text')
              .attr('class', 'value')
              .attr('x', 25 + textWidth / 2)
              .attr('y', -20 + textHeight / 2)
              .attr('dy', '0.20em')               
              .style('font-size', '20px')
              .style('font-weight', '500')
              .style('fill', 'white')
              .attr('text-anchor', 'middle')
              .text(upTimeText);



        var lineData = [[config.pointerWidth / 2, 0],
        [0, -pointerHeadLength],
        [-(config.pointerWidth / 2), 0],
        [0, config.pointerTailLength],
        [config.pointerWidth / 2, 0]];
        var pointerLine = d3.line().curve(d3.curveLinear)
        var pg = svg.append('g').data([lineData])
          .attr('class', 'pointer')
          .attr('transform', centerTx);

        pointer = pg.append('path')
          .attr('d', pointerLine/*function(d) { return pointerLine(d) +'Z';}*/)
          .attr('transform', 'rotate(' + config.minAngle + ')');

        update(newValue === undefined ? 0 : newValue);
      }
      self.gaugemap.render = render;
      function update(newValue, newConfiguration?) {
        if (newConfiguration !== undefined) {
          configure(newConfiguration);
        }
        var ratio = scale(newValue);
        var newAngle = config.minAngle + (ratio * range);
        pointer.transition()
          .duration(config.transitionMs)
          .ease(d3.easeElastic)
          .attr('transform', 'rotate(' + newAngle + ')');
      }
      self.gaugemap.update = update;

      configure(configuration);

      return self.gaugemap;
    };

    var gauge1 = function (container, configuration) {

      var config = {
        size: 710,
        clipWidth: 200,
        clipHeight: 110,
        ringInset: 20,
        ringWidth: 20,

        pointerWidth: 10,
        pointerTailLength: 5,
        pointerHeadLengthPercent: 0.9,

        minValue: 0,
        maxValue: 100,

        minAngle: -90,
        maxAngle: 90,

        transitionMs: 750,

        majorTicks: 10,
        labelFormat: d3.format('d'),
        labelInset: 10,

        arcColorFn: d3.interpolateHsl(d3.rgb('#f2d4d4'), d3.rgb('#c40d0d'))
      };
      
      var range = undefined;
      var r = undefined;
      var pointerHeadLength = undefined;
      var value = 0;

      var svg = undefined;
      var arc = undefined;
      var scale = undefined;
      var ticks = undefined;
      var tickData = undefined;
      var pointer = undefined;

      var donut = d3.pie();

      function deg2rad(deg) {
        return deg * Math.PI / 180;
      }

      function newAngle(d) {
        var ratio = scale(d);
        var newAngle = config.minAngle + (ratio * range);
        return newAngle;
      }

      function configure(configuration) {
        var prop = undefined;
        for (prop in configuration) {
          config[prop] = configuration[prop];
        }

        range = config.maxAngle - config.minAngle;
        r = config.size / 2;
        pointerHeadLength = Math.round(r * config.pointerHeadLengthPercent);

        scale = d3.scaleLinear()
          .range([0, 1])
          .domain([config.minValue, config.maxValue]);

        ticks = scale.ticks(config.majorTicks);
        tickData = d3.range(config.majorTicks).map(function () { return 1 / config.majorTicks; });

        arc = d3.arc()
          .innerRadius(r - config.ringWidth - config.ringInset)
          .outerRadius(r - config.ringInset)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + (ratio * range));
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + (ratio * range));
          });
      }
      self.gaugemap.configure = configure;

      function centerTranslation() {
        return 'translate(' + r + ',' + r + ')';
      }

      function isRendered() {
        return (svg !== undefined);
      }
      self.gaugemap.isRendered = isRendered;

      function render(newValue) {
        svg = d3.select(container)
          .append('svg:svg')
          .attr('class', 'gauge')
          .attr('width', config.clipWidth)
          .attr('height', config.clipHeight);

        var centerTx = centerTranslation();

        var arcs = svg.append('g')
          .attr('class', 'arc')
          .attr('transform', centerTx);

        arcs.selectAll('path')
          .data(tickData)
          .enter().append('path')
          .attr('fill', function (d, i) {
            return config.arcColorFn(d * i);
          })
          .attr('d', arc);

        var lg = svg.append('g')
          .attr('class', 'label')
          .attr('transform', centerTx);
        lg.selectAll('text')
          .data(ticks)
          .enter().append('text')
          .attr('transform', function (d) {
            var ratio = scale(d);
            var newAngle = config.minAngle + (ratio * range);
            return 'rotate(' + newAngle + ') translate(0,' + (config.labelInset - r) + ')';
          })
          .style('font-size', '10px')
          .text(config.labelFormat);

          var group = svg.append('g')
          .attr('transform', 'translate(' + (config.clipWidth / 2) + ',' + 200 + ')')
          .style('display', 'flex')
          .style('flex-direction', 'row')
          .style('align-items', 'center');

          group.append('text')
          .attr('class', 'title')
          .attr('text-anchor', 'end')
          .attr('x', 0)
          .style('font-size', '20px')
          .style('font-weight', 'bold')
          .style('fill', '#D43838')
          .text('DOWN TIME');

          var downTime = parseFloat(self.downTime);
          var downTimeText;
          
          if (downTime % 1 === 0) {
            downTimeText = parseInt(downTime.toString()) + ' '+'%';
          } else {
            downTimeText = downTime.toFixed(2) + ' '+'%';
          }  

          var textWidth = 100;
          var textHeight = 30;
          
          group.append('rect')
              .attr('x', 25)
              .attr('y', -23)
              .attr('width', textWidth)
              .attr('height', textHeight)
              .attr('rx', 10)
              .attr('ry', 10)
              .style('fill', '444444');
      
          group.append('text')
              .attr('class', 'value')
              .attr('x', 25 + textWidth / 2)
              .attr('y', -20 + textHeight / 2)
              .attr('dy', '0.20em')               
              .style('font-size', '20px')
              .style('font-weight', '500')
              .style('fill', 'white')
              .attr('text-anchor', 'middle')
              .text(downTimeText);


        var lineData = [[config.pointerWidth / 2, 0],
        [0, -pointerHeadLength],
        [-(config.pointerWidth / 2), 0],
        [0, config.pointerTailLength],
        [config.pointerWidth / 2, 0]];
        var pointerLine = d3.line().curve(d3.curveLinear)
        var pg = svg.append('g').data([lineData])
          .attr('class', 'pointer')
          .attr('transform', centerTx);

        pointer = pg.append('path')
          .attr('d', pointerLine/*function(d) { return pointerLine(d) +'Z';}*/)
          .attr('transform', 'rotate(' + config.minAngle + ')');

        update(newValue === undefined ? 0 : newValue);
      }
      self.gaugemap.render = render;
      function update(newValue, newConfiguration?) {
        if (newConfiguration !== undefined) {
          configure(newConfiguration);
        }
        var ratio = scale(newValue);
        var newAngle = config.minAngle + (ratio * range);
        pointer.transition()
          .duration(config.transitionMs)
          .ease(d3.easeElastic)
          .attr('transform', 'rotate(' + newAngle + ')');
      }
      self.gaugemap.update = update;

      configure(configuration);

      return self.gaugemap;
    };

    var gauge2 = function (container, configuration) {

      var config = {
        size: 710,
        clipWidth: 200,
        clipHeight: 110,
        ringInset: 20,
        ringWidth: 20,

        pointerWidth: 10,
        pointerTailLength: 5,
        pointerHeadLengthPercent: 0.9,

        minValue: 0,
        maxValue: 100,

        minAngle: -90,
        maxAngle: 90,

        transitionMs: 750,

        majorTicks: 10,
        labelFormat: d3.format('d'),
        labelInset: 10,

        arcColorFn: d3.interpolateHsl(d3.rgb('#f2dab3'), d3.rgb('#ff7f00'))
      };
      
      var range = undefined;
      var r = undefined;
      var pointerHeadLength = undefined;
      var value = 0;

      var svg = undefined;
      var arc = undefined;
      var scale = undefined;
      var ticks = undefined;
      var tickData = undefined;
      var pointer = undefined;

      var donut = d3.pie();

      function deg2rad(deg) {
        return deg * Math.PI / 180;
      }

      function newAngle(d) {
        var ratio = scale(d);
        var newAngle = config.minAngle + (ratio * range);
        return newAngle;
      }

      function configure(configuration) {
        var prop = undefined;
        for (prop in configuration) {
          config[prop] = configuration[prop];
        }

        range = config.maxAngle - config.minAngle;
        r = config.size / 2;
        pointerHeadLength = Math.round(r * config.pointerHeadLengthPercent);

        scale = d3.scaleLinear()
          .range([0, 1])
          .domain([config.minValue, config.maxValue]);

        ticks = scale.ticks(config.majorTicks);
        tickData = d3.range(config.majorTicks).map(function () { return 1 / config.majorTicks; });

        arc = d3.arc()
          .innerRadius(r - config.ringWidth - config.ringInset)
          .outerRadius(r - config.ringInset)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + (ratio * range));
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + (ratio * range));
          });
      }
      self.gaugemap.configure = configure;

      function centerTranslation() {
        return 'translate(' + r + ',' + r + ')';
      }

      function isRendered() {
        return (svg !== undefined);
      }
      self.gaugemap.isRendered = isRendered;

      function render(newValue) {
        svg = d3.select(container)
          .append('svg:svg')
          .attr('class', 'gauge')
          .attr('width', config.clipWidth)
          .attr('height', config.clipHeight);

        var centerTx = centerTranslation();

        var arcs = svg.append('g')
          .attr('class', 'arc')
          .attr('transform', centerTx);

        arcs.selectAll('path')
          .data(tickData)
          .enter().append('path')
          .attr('fill', function (d, i) {
            return config.arcColorFn(d * i);
          })
          .attr('d', arc);

        var lg = svg.append('g')
          .attr('class', 'label')
          .attr('transform', centerTx);
        lg.selectAll('text')
          .data(ticks)
          .enter().append('text')
          .attr('transform', function (d) {
            var ratio = scale(d);
            var newAngle = config.minAngle + (ratio * range);
            return 'rotate(' + newAngle + ') translate(0,' + (config.labelInset - r) + ')';
          })
          .style('font-size', '10px')
          .text(config.labelFormat);

          var group = svg.append('g')
          .attr('transform', 'translate(' + (config.clipWidth / 2) + ',' + 200 + ')')
          .style('display', 'flex')
          .style('flex-direction', 'row')
          .style('align-items', 'center');

          group.append('text')
          .attr('class', 'title')
          .attr('text-anchor', 'end')
          .attr('x', 0)
          .style('font-size', '20px')
          .style('font-weight', 'bold')
          .style('fill', '#ff7f00')
          .text('PSD TIME');

          var partialTime = parseFloat(self.partialtime);
          var partialTimeText;
          
          if (partialTime % 1 === 0) {
            partialTimeText = parseInt(partialTime.toString()) + ' '+'%';
          } else {
            partialTimeText = partialTime.toFixed(2) + ' '+'%';
          }

          var textWidth = 100;
          var textHeight = 30;
          
          group.append('rect')
              .attr('x', 25)
              .attr('y', -23)
              .attr('width', textWidth)
              .attr('height', textHeight)
              .attr('rx', 10)
              .attr('ry', 10)
              .style('fill', '444444');  
      
          group.append('text')
              .attr('class', 'value')
              .attr('x', 25 + textWidth / 2)
              .attr('y', -20 + textHeight / 2)
              .attr('dy', '0.20em') 
              .style('font-size', '20px')             
              .style('font-weight', '500')
              .style('fill', 'white')
              .attr('text-anchor', 'middle')
              .text(partialTimeText);


        var lineData = [[config.pointerWidth / 2, 0],
        [0, -pointerHeadLength],
        [-(config.pointerWidth / 2), 0],
        [0, config.pointerTailLength],
        [config.pointerWidth / 2, 0]];
        var pointerLine = d3.line().curve(d3.curveLinear)
        var pg = svg.append('g').data([lineData])
          .attr('class', 'pointer')
          .attr('transform', centerTx);

        pointer = pg.append('path')
          .attr('d', pointerLine/*function(d) { return pointerLine(d) +'Z';}*/)
          .attr('transform', 'rotate(' + config.minAngle + ')');

        update(newValue === undefined ? 0 : newValue);
      }
      self.gaugemap.render = render;
      function update(newValue, newConfiguration?) {
        if (newConfiguration !== undefined) {
          configure(newConfiguration);
        }
        var ratio = scale(newValue);
        var newAngle = config.minAngle + (ratio * range);
        pointer.transition()
          .duration(config.transitionMs)
          .ease(d3.easeElastic)
          .attr('transform', 'rotate(' + newAngle + ')');
      }
      self.gaugemap.update = update;

      configure(configuration);

      return self.gaugemap;
    };


   let ele=  document.getElementById("power") as HTMLElement;
   let ele1=  document.getElementById("power1") as HTMLElement;
   let ele2 =  document.getElementById("power2") as HTMLElement;

    if(ele && ele != null && ele != undefined){
    ele.innerHTML = '';
    var powerGauge = gauge(ele, {
      size: 300,
      clipWidth: 300,
      clipHeight: 300,
      ringWidth: 90,
      maxValue: 100,
      transitionMs: 4000,
    });
    powerGauge.render(self.upTime);
  }

  if(ele1 && ele1 != undefined && ele1 != null){
    ele1.innerHTML = '';
    var powerGauge1 = gauge1(ele1, {
      size: 300,
      clipWidth: 300,
      clipHeight: 300,
      ringWidth: 90,
      maxValue: 100,
      transitionMs: 4000,
    });
    powerGauge1.render(self.downTime);  
  }


    if(ele2 && ele2 != undefined && ele2 != null){
      ele2.innerHTML = '';
      var powerGauge2 = gauge2(ele2, {
        size: 300,
        clipWidth: 300,
        clipHeight: 300,
        ringWidth: 90,
        minValue: 0,
        maxValue: 100,
        transitionMs: 4000,
      });
      powerGauge2.render(self.partialtime);
    }
}


}
